import { api } from "@/lib/api-client";
import type { AboutPageContent, AboutPageInput } from "./types";

function normalize(input: AboutPageInput): AboutPageInput {
  return {
    ...input,
    subtitle: input.subtitle || null,
    profileImageUrl: input.profileImageUrl || null,
    biography: input.biography || "",
    ctaHeadline: input.ctaHeadline || null,
    ctaDescription: input.ctaDescription || null,
    ctaButtonText: input.ctaButtonText || null,
    ctaButtonUrl: input.ctaButtonUrl || null,
    specialties: input.specialties.map((item) => ({ ...item, icon: item.icon || null, sortOrder: item.sortOrder ?? 0 })),
    timeline: input.timeline.map((item) => ({ ...item, sortOrder: item.sortOrder ?? 0 })),
    faqs: input.faqs.map((item) => ({ ...item, sortOrder: item.sortOrder ?? 0 })),
  };
}

export const aboutApi = {
  get: () => api.get<AboutPageContent>("/about"),
  update: (input: AboutPageInput) => api.patch<AboutPageContent>("/about", normalize(input)),
};
